import HomeBannerimage from "./home-header-image.png";
import LeftBannerimage from "./leftBannerSplash.png";

import CoatOfArms from "./coat-of-arms.png";
import EnuguIRS from "./enugu-irs.png";
import EnuguState from "./enugu-state.png";

import WhoWeAre from "./who-we-are-image.png";

import Services1 from "./image-1.png";
import Services2 from "./image-2.png";
import Services3 from "./image-3.png";
import Services4 from "./image-4.png";
import Services5 from "./image-5.png";
import Services6 from "./image-6.png";
import Services7 from "./image-7.png";

import ContactFormImage from "./contact-form-image.png";

import VisionImage from "./vision-image.png";
import MissionImage from "./mission-image.png";
import MantraImage from "./mantra-image.png";

import TeamImage from "./team-image.png";

export {
    HomeBannerimage,
    LeftBannerimage,

    CoatOfArms,
    EnuguIRS,
    EnuguState,

    WhoWeAre,

    Services1,
    Services2,
    Services3,
    Services4,
    Services5,
    Services6,
    Services7,

    ContactFormImage,
    VisionImage,
    MissionImage,
    MantraImage,

    TeamImage

}